export enum DraftEmailActions {
    Canceled,
    Deleted,
    Saved,
    Sended,
}
